import { Redirect } from "expo-router";
import LScreen from "@components/LScreen";

export default function TabsIndex() {
  return (
    <LScreen>
      <Redirect href="/(app)/(tabs)/home" />
    </LScreen>
  );
}
